<template>
  <div class="date-picker">
    <div class="date-wrap">
      <p>{{ formattedLabel }}</p>
      <div class="caret">
        <i class="atto atto-caret-down-b" />
      </div>
    </div>
    <date-range-picker
      ref="dateRangePicker"
      :start-date="startDate"
      :end-date="endDate"
      :ranges="ranges"
      :locale-data="locale"
      :opens="opens"
      @update="onDateSelected"
    />
  </div>
</template>
<script>
import DateRangePicker from "vue2-daterange-picker";

export default {
  name: "DatepickerComponent",
  components: {
    DateRangePicker,
  },
  props: {
    customDate: {
      type: String,
      default: undefined,
    },
  },
  data() {
    let _this = this;
    let from = _this.$moment(_this.$store.state.period.from);
    let to = _this.$moment(_this.$store.state.period.to);
    const today = _this.label.get("today");
    const yesterday = _this.label.get("yesterday");
    const this_week = _this.label.get("this_week");
    const last_week = _this.label.get("last_week");
    const this_month = _this.label.get("this_month");
    const last_month = _this.label.get("last_month");
    let rangeLabels = {};
    rangeLabels[today] = [
      _this.$moment().startOf("day"),
      _this.$moment().endOf("day"),
    ];
    rangeLabels[yesterday] = [
      _this
        .$moment()
        .subtract(1, "days")
        .startOf("day"),
      _this
        .$moment()
        .subtract(1, "days")
        .endOf("day"),
    ];
    rangeLabels[this_week] = [
      _this.$moment(_this.$store.state.thisWeek.from).startOf("day"),
      _this.$moment(_this.$store.state.thisWeek.to).endOf("day"),
    ];
    rangeLabels[last_week] = [
      _this
        .$moment(_this.$store.state.thisWeek.from)
        .subtract(1, "week")
        .startOf("day"),
      _this
        .$moment(_this.$store.state.thisWeek.from)
        .add(-1, "day")
        .endOf("day"),
    ];
    rangeLabels[this_month] = [
      _this.$moment().startOf("month"),
      _this.$moment().endOf("month"),
    ];
    rangeLabels[last_month] = [
      _this
        .$moment()
        .subtract(1, "month")
        .startOf("month"),
      _this
        .$moment()
        .subtract(1, "month")
        .endOf("month"),
    ];

    if (this.customDate !== undefined) {
      let dates = this.customDate.split("/");
      from = _this.$moment(dates[0]);
      to = _this.$moment(dates[1]);
    }

    return {
      fromFormatted: from.format("MMM D, YYYY"),
      toFormatted: to.format("MMM D, YYYY"),
      startDate: from.startOf("day"),
      endDate: to.endOf("day"),
      opens: "left",
      nativeEvent: null,
      preventDefault: null,
      stopPropagation: null,
      locale: {
        direction: "ltr",
        format: "MMM D, YYYY",
        separator: "",
        applyLabel: this.label.get("apply"),
        cancelLabel: this.label.get("clear"),
        customRangeLabel: this.label.get("custom_range"),
        daysOfWeek: _this.$moment.weekdaysMin(),
        monthNames: _this.$moment.monthsShort(),
        firstDay: 1,
        showWeekNumbers: false,
      },
      ranges: rangeLabels,
    };
  },
  computed: {
    formattedLabel() {
      if (this.customDate) {
        return `${this.fromFormatted} - ${this.toFormatted}`;
      }
      if (this.$store.state.period.from === this.$store.state.period.to) {
        return this.$store.state.period.fromFormatted;
      }
      return `${this.$store.state.period.fromFormatted} - ${this.$store.state.period.toFormatted}`;
    },
  },
  mounted() {
    const _this = this;
    const datePicker = _this.$refs.dateRangePicker;
    datePicker.$watch("open", function(val) {
      _this.$store.commit("overlay", val);
    });

    datePicker.$el.lastElementChild.addEventListener("click", function(event) {
      setTimeout(function() {
        const clearBtn = datePicker.$el.getElementsByClassName("cancelBtn")[0];
        const ranges = datePicker.$el.getElementsByClassName("ranges")[0];
        const todayLang = _this.label.get("today");
        const yesterdayLang = _this.label.get("yesterday");
        const thisWeekLang = _this.label.get("this_week");
        const lastWeekLang = _this.label.get("last_week");
        const thisMonthLang = _this.label.get("this_month");
        const lastMonthLang = _this.label.get("last_month");

        const today = datePicker.ranges[todayLang];
        const yesterday = datePicker.ranges[yesterdayLang];
        const thisWeek = datePicker.ranges[thisWeekLang];
        const lastWeek = datePicker.ranges[lastWeekLang];
        const thisMonth = datePicker.ranges[thisMonthLang];
        const lastMonth = datePicker.ranges[lastMonthLang];
        const startDate = _this.$moment(datePicker.start);
        const endDate = _this.$moment(datePicker.end);

        if (
          today[0].format("YYYY-MM-DD") === startDate.format("YYYY-MM-DD") &&
          today[1].format("YYYY-MM-DD") === endDate.format("YYYY-MM-DD")
        ) {
          ranges.firstChild.childNodes[0].classList.add("active");
        } else if (
          yesterday[0].format("YYYY-MM-DD") ===
            startDate.format("YYYY-MM-DD") &&
          yesterday[1].format("YYYY-MM-DD") === endDate.format("YYYY-MM-DD")
        ) {
          ranges.firstChild.childNodes[1].classList.add("active");
        } else if (
          thisWeek[0].format("YYYY-MM-DD") === startDate.format("YYYY-MM-DD") &&
          thisWeek[1].format("YYYY-MM-DD") === endDate.format("YYYY-MM-DD")
        ) {
          ranges.firstChild.childNodes[2].classList.add("active");
        } else if (
          lastWeek[0].format("YYYY-MM-DD") === startDate.format("YYYY-MM-DD") &&
          lastWeek[1].format("YYYY-MM-DD") === endDate.format("YYYY-MM-DD")
        ) {
          ranges.firstChild.childNodes[3].classList.add("active");
        } else if (
          thisMonth[0].format("YYYY-MM-DD") ===
            startDate.format("YYYY-MM-DD") &&
          thisMonth[1].format("YYYY-MM-DD") === endDate.format("YYYY-MM-DD")
        ) {
          ranges.firstChild.childNodes[4].classList.add("active");
        } else if (
          lastMonth[0].format("YYYY-MM-DD") ===
            startDate.format("YYYY-MM-DD") &&
          lastMonth[1].format("YYYY-MM-DD") === endDate.format("YYYY-MM-DD")
        ) {
          ranges.firstChild.childNodes[5].classList.add("active");
        }

        clearBtn.addEventListener("click", function(event) {
          event.preventDefault();
          _this.$refs.dateRangePicker.open = true;
          _this.$refs.dateRangePicker.start = null;
          _this.$refs.dateRangePicker.end = null;
        });

        ranges.firstChild.addEventListener("click", function(event) {
          ranges.firstChild.childNodes.forEach((el) => {
            el.classList.remove("active");
          });
          event.target.classList.add("active");
        });
      }, 30);
    });
  },
  methods: {
    onDateSelected: function(dateRange) {
      if (dateRange.endDate === null) {
        dateRange.endDate = dateRange.startDate;
      }
      this.$emit("onDateSelected", dateRange);
    },
  },
};
</script>
<style lang="scss">
@import "~vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css";

.date-picker {
  width: auto;
  height: 48px;
  margin-left: auto;
  position: relative;
  @include base-transition(ease 0.1s all);

  .date-wrap {
    position: relative;
    width: 100%;
    height: 44px;
    top: 0px;
    left: 0px;
    z-index: 1;
    padding: 0 6px;
    display: flex;
    flex-direction: row;
    align-items: center;

    p {
      margin: 0 8px 0 0;
      font: 400 1rem/1.1875rem $roboto-font;
    }
    .caret {
      width: 24px;
      height: 24px;
      margin-left: auto;
      text-align: center;
      display: inline-flex;
      align-items: center;
      justify-content: center;

      i {
        color: #c9c9c9;
        font-size: 0.75rem;
      }
    }
  }

  > div:not(.date-wrap) {
    position: absolute;
    width: 100%;
    height: 44px;
    top: -40px;
    left: 0;
    z-index: 2;
  }

  .input-date {
    float: left;
    border: 0 !important;
    width: 100% !important;
    height: 44px;
  }

  .form-control {
    border: 0;
    padding: 0;
    height: 44px;
    cursor: pointer;
    background-color: transparent;

    > span {
      display: none;
    }
  }

  .calendar {
    top: 66px !important;
    left: auto !important;
    right: 0 !important;
    transform: translate(0) !important;
    height: auto !important;
    width: auto !important;
    min-width: 920px;
    padding: 61px 61px 33px 61px;
    border: 0;
    border-radius: 0;

    .calendar-head {
      display: none;
    }

    .calendar-wrap,
    .calendar-range {
      padding: 0;
      width: auto;
    }

    .calendar-wrap {
      .calendar_month_left {
        margin: 0;
        padding: 0 20px 0 0;
        width: auto;
      }

      .calendar_month_right {
        margin: 0;
        padding: 0 0 0 20px;
        width: auto;
      }
    }

    .calendar-range {
      width: 158px;
      float: left;
      margin: 0 0 0 40px;
      border-left: 0;

      .calendar_preset {
        margin-top: 8px;

        li {
          display: flex;
          flex-direction: column;
          padding: 0;
          margin-top: 0;
          margin-bottom: 16px;
          font-size: 0.875rem;
          line-height: 1.5rem;
          font-weight: 500;
          font-family: $roboto-font;
          color: $atto-font-color;
          position: relative;

          &:hover {
            background-color: transparent;
          }

          &:nth-child(3),
          &:nth-child(5) {
            &:before {
              content: "";
              float: left;
              clear: both;
              margin: 11px 0 27px;
              width: 32px;
              height: 2px;
              background-color: #efefef;
            }
          }

          button.calendar-btn-apply {
            margin-top: 24px;
            width: 100px;
            text-align: right;
            margin-left: auto;
            background-color: transparent;
            color: $atto-green;
            padding: 0;
            font-size: 1.125rem;
            line-height: 1.5rem;
            font-weight: 500;
            cursor: pointer;
          }

          &.active-preset {
            color: $atto-green;
            border: 0;
          }
        }
      }
    }
  }

  .daterangepicker {
    top: 61px !important;
    padding: 61px 61px 39px;
    min-width: 922px !important;
    border: 0;
    border-radius: 0;

    .calendars {
      justify-content: flex-start;

      .ranges {
        border-right: 0;
        order: 2;
        float: right;
        display: inline-flex;
        width: 172px;
        padding: 8px 0 0 0;
        margin-top: 0;
        margin-left: 40px;

        ul {
          padding: 0;
          width: 100%;

          li {
            display: flex;
            flex-direction: column;
            padding: 0;
            margin-top: 0;
            padding-bottom: 16px;
            font-size: 0.875rem;
            line-height: 1.5rem;
            font-weight: 500;
            font-family: $roboto-font;
            color: $atto-font-color;
            position: relative;
            @include base-transition(ease all 0.15s);

            &:hover {
              background-color: transparent;
              color: #00b9cb;
            }

            &:nth-child(3),
            &:nth-child(5) {
              &:before {
                content: "";
                float: left;
                clear: both;
                margin: 11px 0 27px;
                width: 32px;
                height: 2px;
                background-color: #efefef;
              }
            }

            &:last-child {
              margin-bottom: 0;
            }

            &.active {
              color: #00b9cb;
              background-color: transparent;

              &:after {
                content: "\E9B1";
                color: #00b9cb;
                width: 24px;
                height: 24px;
                position: absolute;
                right: 0;
                bottom: 17px;
                font-family: "attotime" !important;
                font-size: 10px;
                speak: none;
                font-style: normal;
                font-weight: normal;
                font-variant: normal;
                text-transform: none;
                line-height: 1;
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                display: inline-flex;
                align-items: center;
                justify-content: center;
              }
            }
          }
        }
      }

      .drp-calendar {
        padding: 0;
        max-width: 280px;

        &.left {
          border-left: 0;
          margin-right: 40px;

          .calendar-table {
            table {
              thead {
                tr {
                  th.prev {
                    width: 40px;
                    height: 40px;
                    padding: 0;
                    border: 1px solid #efefef;
                    // Left Arrow
                    font-size: 1rem;
                    color: #c7c7c7;
                    font-family: "attotime" !important;
                    speak: none;
                    font-style: normal;
                    font-weight: normal;
                    font-variant: normal;
                    text-transform: none;
                    line-height: 1;

                    /* Better Font Rendering =========== */
                    -webkit-font-smoothing: antialiased;
                    -moz-osx-font-smoothing: grayscale;

                    &:before {
                      content: "\E940";
                    }

                    span {
                      display: none;
                    }
                  }

                  th.next {
                    /*display: none!important;*/
                    opacity: 0;
                    cursor: auto;
                  }
                }
              }
            }
          }
        }

        &.right {
          .calendar-table {
            table {
              thead {
                tr {
                  th.next {
                    width: 40px;
                    height: 40px;
                    padding: 0;
                    border: 1px solid #efefef;
                    // Right Arrow
                    font-size: 1rem;
                    color: #c7c7c7;
                    font-family: "attotime" !important;
                    speak: none;
                    font-style: normal;
                    font-weight: normal;
                    font-variant: normal;
                    text-transform: none;
                    line-height: 1;

                    /* Better Font Rendering =========== */
                    -webkit-font-smoothing: antialiased;
                    -moz-osx-font-smoothing: grayscale;

                    &:before {
                      content: "\E986";
                    }

                    span {
                      display: none;
                    }
                  }

                  th.prev {
                    /*display: none!important;*/
                    opacity: 0;
                    cursor: auto;
                  }
                }
              }
            }
          }
        }

        .calendar-table {
          padding: 0 !important;

          table {
            border: 0 !important;

            thead {
              tr {
                th {
                  &.month {
                    border: 0;
                    padding: 0;
                    font-size: 1.125rem;
                    line-height: 24px;
                    font-family: $roboto-font;
                    font-weight: 500;
                    color: $atto-font-color;
                  }
                }
              }
            }

            tbody {
              tr {
                th {
                  width: 40px;
                  height: 40px;
                  min-width: inherit;
                  font-size: 0.875rem;
                  line-height: 1.5rem;
                  padding: 8px 0;
                  font-family: $roboto-font;
                  font-weight: 400;
                  color: #999;
                  border-radius: 0;
                  border: 0;
                }

                td {
                  width: 40px;
                  min-width: inherit;
                  height: 40px;
                  font-size: 0.875rem;
                  line-height: 1.5rem;
                  padding: 8px 0;
                  font-family: $roboto-font;
                  font-weight: 400;
                  color: #262626;
                  border-radius: 0;
                  border: 1px solid #efefef;

                  &.off {
                    // Need to rethink how to manage last row and first row off table-cells
                    background-color: transparent !important;
                    border-color: #efefef;
                    color: #efefef !important;
                    cursor: context-menu;
                  }

                  &.weekend {
                  }

                  &.in-range {
                    color: #fff;
                    background-color: #00b9cb;
                    border-color: #00b9cb;
                  }

                  &.in-range.active {
                    color: #fff;
                    background-color: #0a9ead;
                    border-color: #0a9ead;
                  }

                  &.in-range.start-date.off,
                  &.in-range.end-date.off {
                    color: #efefef;
                    background-color: transparent;
                    border-color: #efefef;
                  }

                  &.in-range.off {
                    border-color: #efefef;
                  }

                  &.today {
                    font-weight: 500;
                  }

                  &:not(.in-range):not(.active):hover {
                    background-color: $atto-light-grey;
                  }
                }

                &:nth-child(2) {
                  td.off {
                    border-bottom: 1px solid #efefef !important;
                  }

                  td.off:not(.off) ~ td {
                    border-left: 1px solid #efefef;
                  }
                }
              }
            }
          }
        }
      }
    }

    .drp-buttons {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      justify-content: flex-end;
      padding: 34px 0 0;
      border-top: 0;

      button {
        border: 0;
        border-radius: 0;
        width: 100px;
        text-align: right;
        margin-left: 29px;
        background-color: transparent;
        font-family: $roboto-font;
        padding: 0;
        font-size: 1.125rem;
        line-height: 1.5rem;
        font-weight: 500;
        cursor: pointer;

        &.cancelBtn {
          color: $atto-dark-grey;
          font-weight: 500;
        }

        &.applyBtn {
          color: $atto-green;
          font-weight: 700;

          &.btn-success {
            &:focus,
            &:not(:disabled):not(.disabled):active {
              background-color: transparent;
              color: #00b9cb;
              outline: 0;
              box-shadow: none;
            }
          }
        }

        &:active,
        &:focus,
        &:active:focus {
          outline: 0;
          box-shadow: none;
        }
      }

      .drp-selected {
        display: none;
      }
    }

    &.opensleft {
      right: 0 !important;
    }

    &:before {
      border: 0 !important;
      width: 22px;
      height: 22px;
      border-radius: 3px;
      background-color: #fff;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
      top: -9px;
    }

    &:after {
      content: none;
    }
  }

  &:hover {
    border-color: $atto-dark-grey;
  }
}
</style>
